<template>

<div class="my-dialog">
      <el-dialog
           :visible.sync="dialogVisible"
            v-dialogDrag
            v-model="dialogData"
            :showClose=dialogData.showClo
            :close-on-click-modal="false"
            @opened="onOpened"
            @close="onClose"

            >
    <div slot="title" >
        <b>{{title}}</b>
    </div>

        <components v-if="componentName" ref="component_ref" :is="TickName"/>

    </el-dialog>

</div>

</template>
<script>
       export default {
        name: "eDialog",
          props: {
              activePage:String,
          },
        watch: {
            activePage:{
                handler(value){

                    if(value)this.componentName=value;
                },
                immediate: true
            }
        },
        data(){

            return {
                componentName:null,
                dialogVisible:false,
                dialogData:{},
                title:"查询",

            };
        },

          computed:{
              TickName: function (){

                  if(this.componentName){

                      let c = () => import(`@/views/${this.componentName}`);          // 动态组件

                      return c
                  }
              }
          },
        mounted() {

        },
        methods: {

            onOpened(){
                 this.$refs.component_ref.onOpen(this.dialogData);
            },
            onClose(){
                $(".my-dialog").height(0);
                this.$refs.component_ref.resetData();
            },
            showDialog(item) {
                this.dialogData=item;
                 if (item.hasOwnProperty("title")) this.title=item.title;
                $(".my-dialog").height(item.h);
                 $(".my-dialog").find(".el-dialog")[0].style.width= item.w+"px";
                 $(".my-dialog").find(".el-dialog")[0].style.height=item.h+"px";

                 // let el=$(".my-dialog").find(".el-dialog__body")[0];
                 //   if(el){
                 //       //el.style.height=(item.h - 40) +"px";
                 //         el.style['max-height'] = 'none';
                 //   //     $(el).children().height(item.h - 45);
                 //      }

                this.dialogVisible=true;
                window.dispatchEvent(new Event("resize"));
            },
        }
    };


</script>

<style lang="scss" >

    .my-dialog {
        overflow: hidden;

   ::v-deep    .el-dialog {
       display: flex;
       display: -ms-flex; /* 兼容IE */
       flex-direction: column;
       -ms-flex-direction: column; /* 兼容IE */
       margin: 0;

       overflow: hidden;
       position: absolute;
       top: 50% !important;
       left: 50% !important;
       transform: translate(-50%, -50%) !important;
       max-height: calc(100% - 20px) !important;
       max-width: calc(100% - 20px) !important;

   }
        .el-dialog__header {
           background: #1d5987;
           height: 32px;

           margin: 0px;
           padding: 3px 2px;
           color: #a3abb8;
           outline: none;
           cursor: pointer;
           text-align: left;
           line-height: 32px;

       }


        .el-dialog__title{
            line-height: 1;
            font-size: 16px;
            color: #fff;
        }
        .el-dialog__headerbtn{
            top: 13px;
            right: 15px;
        }
        .el-dialog__body {
            padding: 0px;

            height: calc(100% - 40px);
            flex: 1;
            -ms-flex: 1 1 auto; /* 兼容IE */
            overflow-y: auto;
            overflow-x: hidden;
        }

        .el-dialog__wrapper {
            height:100%;
            /*隐藏ie和edge中遮罩的滚动条*/
            overflow: hidden;
        }

        .dialogClass .el-dialog__footer {
            text-align: right;
        }

        // 修改弹框边框圆角
        .el-dialog.el-dialog--center {
            border-radius: 8px;
        }

        // 去掉弹框内容的默认padding值
        .el-dialog--center .el-dialog__body {
            padding: 0px;
            text-align: center;
        }


    }
</style>
